import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import MainLayout from '../../components/layouts/MainLayout';
import Button from '../../components/common/Button';
import Card from '../../components/common/Card';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import { useCart } from '../../hooks/useCart';
import { useAddresses } from '../../hooks/useAddresses';
import { useToast } from '../../components/common/Toast';
import { orderService } from '../../services/order.service';
import { paymentService } from '../../services/payment.service';
import { theme } from '../../config/theme';
import { CheckCircleIcon, XCircleIcon } from '../../components/icons/Icons';

const OrderSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const status = searchParams.get('payment');
  
  const isSuccess = status === 'success';

  return (
    <MainLayout>
      <div style={{ padding: theme.spacing.xl, maxWidth: '600px', margin: '40px auto', textAlign: 'center' }}>
        <Card padding="xl">
          {isSuccess ? (
            <div style={{ color: theme.colors.success, marginBottom: theme.spacing.md }}>
              <CheckCircleIcon size={64} />
            </div>
          ) : (
            <div style={{ color: theme.colors.error, marginBottom: theme.spacing.md }}>
              <XCircleIcon size={64} />
            </div>
          )}
          
          <h1 style={{ fontSize: theme.typography.fontSize['3xl'], marginBottom: theme.spacing.md }}>
            {isSuccess ? 'Payment Successful!' : 'Payment Failed'}
          </h1>
          
          <p style={{ color: theme.colors.text.secondary, marginBottom: theme.spacing.xl }}>
            {isSuccess 
              ? 'Thank you for your order. We are now processing it.' 
              : 'There was an issue processing your payment. Please try again or use another payment method.'}
          </p>

          <div style={{ display: 'flex', gap: theme.spacing.md, justifyContent: 'center' }}>
            {isSuccess ? (
              <Button variant="primary" onClick={() => navigate('/orders')}>View Orders</Button>
            ) : (
              <Button variant="primary" onClick={() => navigate('/cart')}>Return to Cart</Button>
            )}
            <Button variant="outline" onClick={() => navigate('/')}>Continue Shopping</Button>
          </div>
        </Card>
      </div>
    </MainLayout>
  );
};

export default OrderSuccess;
